import { create } from 'zustand';

/**
 * The doctor's photo for the app bar. The layout (getLayout) only sees server props, which a client
 * navigation from search does not have (it would show the «noimage» placeholder); the profile page
 * knows the real photo (search card seed → final url) and hands it over here.
 */
export const useProfileBarImage = create<{ image?: string; setImage: (image?: string) => void }>(set => ({
  image: undefined,
  setImage: image => set({ image }),
}));
